import { types } from 'mobx-state-tree'

export const StatisticDataPoint = types.model('StatisticDataPoint').props({
  datetime_recorded: types.string,
  value: types.number,
})
